
// budgets
Vue.component('budgets-drilldown', require('./BudgetReport/vue/budgets-drilldown.vue').default);
Vue.component('budgets-drilldown-inner', require('./BudgetReport/vue/budgets-drilldown-inner.vue').default);
Vue.component('budgets-report', require('./BudgetReport/vue/budgets-report.vue').default);

Vue.component('employer-budgets', require('./BudgetOrder/vue/employer-budgets').default);
Vue.component('employer-billings', require('./BudgetPeriod/vue/employer-billings').default);

// insertion orders
Vue.component('insertion-order-detail', require('./BudgetIo/vue/insertion-order-detail.vue').default);
Vue.component('insertion-order-list', require('./BudgetIo/vue/insertion-order-list.vue').default);
Vue.component('insertion-order-list-row', require('./BudgetIo/vue/insertion-order-list-row.vue').default);

// upsell
Vue.component('upsell-list', require('./BudgetIncrease/vue/upsell-list').default);
Vue.component('upsell-update', require('./BudgetIncrease/vue/upsell-update').default);

// delivery price
Vue.component('delivery-price-removed-charges', require('./DeliveryPriceSetUnset/vue/delivery-price-removed-charges').default);

// performance reports
Vue.component('list-campaign', require('./ListCampaign/vue/list-campaign.vue').default);
Vue.component('list-employer', require('./ListEmployer/vue/list-employer.vue').default);
Vue.component('list-fulfillment', require('./ListFulfillment/vue/list-fulfillment.vue').default);

Vue.component('employer-performance', require('./PerformanceReports/vue/employer-performance.vue').default);

// revenue braintree
Vue.component('employer-assign-form', require('./RevenueBraintree/vue/employer-assign-form.vue').default);
Vue.component('payment-gate', require('./RevenueBraintree/vue/payment-gate.vue').default);

// revenue braintree
Vue.component('employer-assign-form', require('./RevenueBraintree/vue/employer-assign-form.vue').default);
Vue.component('payment-gate', require('./RevenueBraintree/vue/payment-gate.vue').default);

// revenue payments
Vue.component('payments', require('./RevenuePayments/vue/payments-report').default);
Vue.component('orphaned-payments', require('./RevenuePayments/vue/orphaned-payments.vue').default);
Vue.component('employer-payments', require('./RevenuePayments/vue/employer-payments.vue').default);

// board revenue
Vue.component('board-revenue-report', require('./RevenueReport/vue/board-revenue-report.vue').default);
Vue.component('board-revenue-report-by-range', require('./RevenueReport/vue/board-revenue-report-by-range.vue').default);

// revenue stripe
Vue.component('stripe-assign-employer', require('./RevenueStripe/vue/employer-detail/assign-employer.vue').default);
Vue.component('stripe-payment-gateway', require('./RevenueStripe/vue/payment-gateway/payment-gateway.vue').default);

// estimates
Vue.component('budget-estimates', require('./EstimatesUi/vue/budget-estimates.vue').default);

